export const getStorage = (itemName) => {
  return JSON.parse(sessionStorage.getItem(itemName));
};

export const setStorage = (itemName, value) => {
  sessionStorage.setItem(itemName, value);
};
